import type {AxiosRequestConfig} from 'axios';
import {EntityService} from '../../../service/EntityService';

type GroupTypeCodeRequestConfig = AxiosRequestConfig & {
  // MI18N: Cho phép reload labels âm thầm khi đổi language, không bật global loading.
  skipLoading?: boolean;
};

export class InvoiceSettingDefaultService extends EntityService {

  static entity = 'app/invoice-setting-default';

  static getGroupTypeCode(config?: GroupTypeCodeRequestConfig): Promise<any> {
    return this.axios
      .get(`${this.entity}/group-type-code`, config)
      .then(res => res.data);
  }

  static getNumericColumns(typeInvoiceId: string, groupTypeCode: string): Promise<any> {
    return this.axios.get(`${this.entity}/numeric-columns/${typeInvoiceId}`, {params: {typeInvoiceId, groupTypeCode}}).then(res => res.data);
  }

}
